import { Injectable } from '@angular/core';
import { CoreRepository } from '@tcc-mono/shared/data-access';
import { Ride } from '@tcc-mono/vandijk/shared/data-access/models';
import { RideService } from '@tcc-mono/vandijk/shared/data-access/vandijk-api';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RideRepository extends CoreRepository<Ride> {

  public constructor(
    protected readonly _rideService: RideService
  ) {
    super(
      { name: 'rides' },
      _rideService
    );
  }

  public markAnimalKvsRegistered(
    rideId: PropertyKey,
    animalId: PropertyKey
  ): Observable<unknown> {
    return this._rideService.markAnimalKvsRegistered(rideId, animalId);
  }

  public deleteAnimal(
    rideId: PropertyKey,
    animalId: PropertyKey,
    override: boolean = false
  ): Observable<any> {
    return this._rideService.deleteAnimal(
      rideId,
      animalId,
      override
    );
  }
}
